import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Table } from "primeng/table";
import { environment } from "../../../../environments/environment";
import { ArkUserType, ClientModel, ClientUserViewModel, ClientViewModel } from "../../../core/api/models";
import { ClientsApiService } from "../../../core/api/services";
import { Utils } from "../../../core/utils";
import { AuthService } from "../../../main/auth.service";
import { AlertService } from "../../../shared/services/alert.service";

@Component({
  selector: 'app-client-users',
  templateUrl: './client-users.component.html',
  styleUrl: './client-users.component.css',
  standalone: false
})
export class ClientUsersComponent implements OnInit, AfterViewInit {


  public pageTitle: string = 'Client Users';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;

  itemFormGroup!: FormGroup;
  currentItem?: ClientModel;
  client_id: number | null = null;
  baseDomain: string | null = environment.baseDomain;

  clientLoginItem?: ClientUserViewModel;
  clientLoginVisible: boolean = false;
  clientLoginUrl: string | null = null;

  client_users: any[] | null = null;
  loading: boolean = false;
  loadingClientUsers: boolean = false;
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private sanitizer: DomSanitizer) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + (params.get('ID') || '0');
      if (ID > 0) {
        this.client_id = ID;
        console.info('Loading ' + ID);

        this.apiService.Get({ body: { id: ID } })
          .forEach(data => {
            this.loadingList = false;
            this.currentItem = data;
            this.load();
          }).catch(
            err => {
              this.alertService.error(Utils.getAjaxError(err));

            });

      }
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);
    
  }

  ngAfterViewInit(): void {

  }



  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }
    console.log(this.filter);
    this.loadingList = true;
    this.apiService.GetClientUsersDataTable({
      clientID: this.client_id ?? 0,
      body: this.filter
    })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  getClientLogo(client: ClientViewModel | ClientModel, type: string = 'Print'): any {

    var siteName = client.SiteName?.toLocaleLowerCase();
    if (siteName == 'optodev')
      siteName = 'beta';

    //return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/DisplayLogo/${siteName}.png`);
    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {
    this.alertService.info('TO DO - Add new client');
  }


  onRowImpersonate(item: ClientUserViewModel) {
    if (item.Inactive) {
      this.alertService.error("User is inactive.");
      return;
    }
    this.clientLoginItem = item;
    this.client_users = null;
    this.clientLoginUrl = null;
    this.clientLoginVisible = true;

  }


  clientLogin() {


    this.loading = true;
    this.apiService.GetImpersonationLink({ body: { clientID: this.currentItem!.ID || 0, client_userID: this.clientLoginItem!.ID || 0 } }).forEach((r) => {
      this.loading = false;
      this.clientLoginUrl = r;
      var w = window.open(r, this.currentItem!.SiteName || '_blank');
      if (w) {
        this.clientLoginVisible = false;
      }
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });


  }

  onRowEditInit(item: ClientViewModel) {

    this.loadingList = true;


    this.apiService.Get({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }




  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    //this.itemFormGroup.patchValue(this.currentItem);

  }

  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(this.currentItem);


    this.loading = true;
    this.apiService.Save({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }
      ).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));

        }
      );


  }
}
